import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
import { rangoFechasValido, ESPERA_CAMBIO_FECHA_MS } from "../../../../utils/rangoFechasValido";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner,
  Form,
} from "reactstrap";

import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import BajaMultiple from "../../BajaMultiple";
import StatusMultiple from "../../StatusMultiple";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import AutorizadoMultiple from "../../AutorizadoMultiple";
import fmtFecha from "../../../../utils/fmtFecha";

function ListadoAbonos() {
  const { user } = useContext(AuthContext);
  const URL_ABONOS = import.meta.env.VITE_URL_ABONOS;
  const URL_CLIENTES = import.meta.env.VITE_URL_CLIENTES;
  const URL_COLABORADORES = import.meta.env.VITE_URL_COLABORADORES;
  const URL_SEND_MAIL_ATT = import.meta.env.VITE_URL_SEND_MAIL_ATT;
  const URL_LOGS = import.meta.env.VITE_URL_LOGS;
  const URL_ANTICIPOS = import.meta.env.VITE_URL_ANTICIPOS;
  const URL_PEDIDOS = import.meta.env.VITE_URL_PEDIDOS;
  const URL_BANCOS = import.meta.env.VITE_URL_BANCOS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 30);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [abonosTiendas, setAbonosTiendas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedVendedor, setSelectedVendedor] = useState("");
  const [selectedArea, setSelectedArea] = useState("");
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedColaborador, setSelectedColaborador] = useState("");
  const [selectedConcepto, setSelectedConcepto] = useState("");
  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [totalTotalTabla, setTotalTotalTabla] = useState(0);

  const [bancos, setBancos] = useState([]);
  const [formaPago, setFormaPago] = useState("");

  const [idAbonoEdit, setIdAbonoEdit] = useState("");
  const [numeroEdit, setNumeroEdit] = useState("");
  const [fechaEdit, setFechaEdit] = useState("");
  const [idClienteEdit, setIdClienteEdit] = useState("");
  const [importeEdit, setImporteEdit] = useState("");
  const [importeEditViejo, setImporteEditViejo] = useState("");
  const [formaPagoEdit, setFormaPagoEdit] = useState("");
  const [observacionesEdit, setObservacionesEdit] = useState("");
  const [clienteEdit, setClienteEdit] = useState("");
  const [notaEdit, setNotaEdit] = useState("");
  const [modalEdit, setModalEdit] = useState(false);
  const toggleEdit = () => setModalEdit(!modalEdit);
  const [validaBoton, setValidaBoton] = useState(true);
  const [text, setText] = useState(false);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  // Carga (y recarga) la lista de abonos del rango de fechas. Se usa al abrir la pantalla, al
  // cambiar el rango y después de editar/cancelar un abono, en lugar de window.location.reload()
  // (que volvía a descargar TODO: abonos 22 MB + clientes 6 MB + ...).
  const cargarAbonos = useCallback((signal) => {
    return axios
      .get(`${URL_ABONOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
        signal,
      })
      .then((response) => {
        let allVentas = response.data;
        // Array para pagination
        let arrayTabla = allVentas
          .sort((a, b) => (a.idAbono < b.idAbono ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              numero: a.idAbono,
              fecha: a.fecha,
              clientes: a.clientes && a.clientes[0] ? a.clientes[0].nombre_comercial : "Sin cliente",
              idClientes: a.clientes && a.clientes[0] ? a.clientes[0]._id : "",
              bancos: a.bancos && a.bancos[0] ? a.bancos[0].banco : "Sin banco",
              idBancos: a.bancos && a.bancos[0] ? a.bancos[0]._id : "",
              // bancos: a.bancos[0].banco + a.bancos[0].cuenta,
              // idBancos: a.bancos[0]._id,
              formaPago: a.formaPago,
              observaciones: a.observaciones,
              importe: a.importe,
              nota: a.pedidos && a.pedidos[0] ? a.pedidos[0].idPedido : "Sin nota",
              idNota: a.pedidos && a.pedidos[0] ? a.pedidos[0]._id : "",
              editado: a.editado,
              is_active: a.is_active,
              codigoAgrupado: a.codigoAgrupado,
              concepto: a.concepto,
              validado: a.validado,
              vendedor: a.colaboradores && a.colaboradores[0] ? a.colaboradores[0].nombre + " " + a.colaboradores[0].apellido : "Sin Vendedor",
              idVendedor: a.colaboradores && a.colaboradores[0] ? a.colaboradores[0]._id : "",
            };
          })
          .filter(function (el) {
            return el != null;
          });

        setAbonosTiendas(arrayTabla);
        setComments(arrayTabla);
        //
      })
      .catch((err) => {
        if (axios.isCancel(err)) return;
        console.log(err);
      });
  }, [selectedFechaInicio, selectedFechaFin]); // eslint-disable-line react-hooks/exhaustive-deps

  // Al cambiar el rango se cancela la consulta anterior y se lanza la nueva; no se consulta un
  // rango incompleto/invertido (mientras se teclea la fecha) y se espera a que el usuario termine.
  useEffect(() => {
    if (!rangoFechasValido(selectedFechaInicio, selectedFechaFin)) return undefined;
    const controller = new AbortController();
    const espera = setTimeout(() => cargarAbonos(controller.signal), ESPERA_CAMBIO_FECHA_MS);
    return () => {
      clearTimeout(espera);
      controller.abort();
    };
  }, [cargarAbonos]); // eslint-disable-line react-hooks/exhaustive-deps

  // Catálogos (clientes, colaboradores, bancos): solo al montar. Antes se volvían a descargar
  // cada vez que cambiaba una fecha del filtro.
  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_COLABORADORES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allColaboradores = response.data;
        setColaboradores(allColaboradores);
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(URL_BANCOS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allBancos = response.data;
        setBancos(allBancos);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function PDFTabla() {
    let TotalImporte = 0;
    const data = comments
      .filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.numero.toString().includes(search)
      )
      .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
      .map((a) => {
        if (
          (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
          (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (selectedCliente == 0 || selectedCliente == a.idClientes) &&
          (selectedVendedor == 0 || selectedVendedor == a.idVendedor) &&
          (selectedConcepto == 0 || selectedConcepto == a.concepto) &&
          // (selectedBanco == 0 || selectedBanco == a.idBancos) &&
          (formaPago == 0 || formaPago == a.formaPago)
        ) {
          TotalImporte = TotalImporte + a.importe;
          return [
            a.numero,
            a.fecha,
            a.clientes,
            a.formaPago,
            a.observaciones,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.importe),
          ];
        }
      });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });

    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Abonos Tiendas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Forma Pago",
          "Observaciones",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(TotalImporte),
        ],
      ],
    });
    doc.save(`Abonos.pdf`);
  }

  function excel() {
    const dataExcel = comments
      .filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.numero.toString().includes(search)
      )
      .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
      .map((a) => {
        if (
          (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
          (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (selectedCliente == 0 || selectedCliente == a.idClientes) &&
          (selectedVendedor == 0 || selectedVendedor == a.idVendedor) &&
          (selectedConcepto == 0 || selectedConcepto == a.concepto) &&
          // (selectedBanco == 0 || selectedBanco == a.idBancos) &&
          (formaPago == 0 || formaPago == a.formaPago)
        ) {
          return {
            Numero: a.numero,
            Fecha: a.fecha,
            Cliente: a.clientes,
            // Bancos: a.bancos,
            FormaPago: a.formaPago,
            Observaciones: a.observaciones,
            Importe: a.importe,
          };
        }
      });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoAbonosTiendas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoAbonosTiendas",
        sheetFilter: [
          "Numero",
          "Fecha",
          "Cliente",
          "FormaPago",
          "Observaciones",
          "Importe",
        ],
        sheetHeader: [
          "Numero",
          "Fecha",
          "Cliente",
          "FormaPago",
          "Observaciones",
          "Importe",
        ],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    let TotalImporte = 0;
    const data = comments
      .filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.numero.toString().includes(search)
      )
      .sort((a, b) => (a.idAbono > b.idAbono ? 1 : -1))
      .map((a) => {
        if (
          (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
          (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
          (selectedCliente == 0 || selectedCliente == a.idClientes) &&
          (selectedVendedor == 0 || selectedVendedor == a.idVendedor) &&
          (selectedConcepto == 0 || selectedConcepto == a.concepto) &&
          // (selectedBanco == 0 || selectedBanco == a.idBancos) &&
          (formaPago == 0 || formaPago == a.formaPago)
        ) {
          TotalImporte = TotalImporte + a.importe;
          return [
            a.numero,
            a.fecha,
            a.clientes,
            a.formaPago,
            a.observaciones,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
            }).format(a.importe),
          ];
        }
      });

    const dataPDF = Object.values(data);

    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });

    const doc = new jsPDF("landscape", "mm", "a4", true);
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 230, 30, 45, 15);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 140, 15, 38, 18);
    doc.text(`Listado Abonos Tiendas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [
        [
          "Numero",
          "Fecha",
          "Cliente",
          "Forma Pago",
          "Observaciones",
          "Importe",
        ],
      ],
      body: dataPDFLimpia,
      startY: 45,
      foot: [
        [
          "",
          "",
          "",
          "",
          "Total",
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(TotalImporte),
        ],
      ],
    });

    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado Abonos",
          email: mailTo,
          fileName: "ListadoAbonos.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${
           import.meta.env.VITE_TAMANO_LOGO_MAIL
         }" align="center" src="${
            import.meta.env.VITE_LINK_SISTEMA
          }logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${
           import.meta.env.VITE_NOMBRE_INSTITUCION
         }</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Abonos.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${
           import.meta.env.VITE_TELEFONO_INSTITUCION
         }</tr>
         <tr align="right"><br>Powered by <a href="https://sistemify.com"> <img width="20%" align="center" src="${
           import.meta.env.VITE_LINK_SISTEMA
         }Logo-Sistemify-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
        });
        console.log(error);
      });
  }

  async function PDFOC(
    fecha,
    clientes,
    importe,
    nota,
    formaPago,
    observaciones,
    numero
  ) {
    const doc = new jsPDF({ compressPdf: true });
    var img = new Image();
    img.src = "Logo-Sistemify-PDF.png";
    doc.addImage(img, "png", 150, 10, 35, 10);
    var img2 = new Image();
    img2.src = "logoInstitucion.png";
    doc.addImage(img2, "png", 95, 15, 30, 30);
    doc.setFontSize(16);
    doc.text(`${import.meta.env.VITE_NOMBRE_INSTITUCION}`, 90, 53);
    doc.text(`___________________`, 80, 100);
    doc.text(`Firma`, 100, 110);

    doc.autoTable({
      head: [
        [
          "No. Recibo",
          "Fecha",
          "Cliente",
          "Nota",
          "Forma Pago",
          "Observaciones",
          "Importe",
        ],
      ],
      body: [
        [
          numero,
          fecha,
          clientes,
          nota,
          formaPago,
          observaciones,
          new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            maximumFractionDigits: 2,
          }).format(importe),
        ],
      ],
      startY: 60,
    });

    doc.save(`Abono-${numero}.pdf`);
  }

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Forma Pago", field: "formaPago", sortable: true },
    { name: "Concepto", field: "concepto", sortable: true },
    { name: "Observaciones", field: "observaciones", sortable: true },
    { name: "Banco", field: "bancos", sortable: true },
    { name: "Importe", field: "importe", sortable: true },
    { name: "Validado", field: "validado", sortable: true },
    { name: "Recibo", field: "recibo", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.formaPago.toLowerCase().includes(search.toLowerCase()) ||
          comment.observaciones.toLowerCase().includes(search.toLowerCase()) ||
          comment.concepto.toLowerCase().includes(search.toLowerCase()) ||
          comment.importe.toString().includes(search) ||
          comment.numero.toString().includes(search) ||
          comment.bancos.toLowerCase().includes(search.toLowerCase())
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if(selectedVendedor) {
      computedComments = computedComments.filter((e) =>
        e.idVendedor.includes(selectedVendedor)
      );
    }
    if (selectedConcepto) {
      computedComments = computedComments.filter((e) =>
        e.concepto.includes(selectedConcepto)
      );
    }

    if (formaPago) {
      computedComments = computedComments.filter((e) =>
        e.formaPago.includes(formaPago)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }

    let activos = computedComments.filter((e) => e.is_active == "Si");
    let t = activos.map((c) => parseFloat(c.importe));
    let Tt = t.reduce((t, cantidad, index) => t + cantidad, 0);
    setTotalTotalTabla(Tt);

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "importe" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "importe" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "importe" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedVendedor,
    selectedConcepto,
    selectedFechaInicio,
    selectedFechaFin,
    formaPago,
  ]);

  function EditAbono(
    _id,
    numero,
    fecha,
    idClientes,
    importe,
    observaciones,
    formaPago,
    cliente,
    idNota
  ) {
    setIdAbonoEdit(_id);
    setNumeroEdit(numero);
    setFechaEdit(fecha);
    setIdClienteEdit(idClientes);
    setImporteEdit(importe);
    setImporteEditViejo(importe);
    setObservacionesEdit(observaciones);
    setFormaPagoEdit(formaPago);
    setClienteEdit(cliente);
    setNotaEdit(idNota);
    toggleEdit();
  }

  const EditAbonoSave = (event) => {
    event.preventDefault();
    Swal.fire({
      title: "Estas seguro?",
      text: "Se registrará el abono",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Enviar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            `${URL_ABONOS}/${idAbonoEdit}`,
            {
              importe: parseFloat(importeEdit) - parseFloat(importeEditViejo),
              idCliente: idClienteEdit,
              notaEdit,
              fecha: fechaEdit,
              editado: "Si",
              observaciones: observacionesEdit,
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(() => {
            axios.post(
              URL_LOGS,
              {
                tipo: "Editar Abono",
                detalle: `${clienteEdit}`,
                user: user.id,
              },
              {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                },
              }
            );
            Swal.fire("Good job!", "Creado con exito", "success");
            setModalEdit(false);
            cargarAbonos();
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  };

  function cancelarAbono(idAbono) {
    Swal.fire({
      title: "Estas seguro?",
      text: "Se cancelara el Abono!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cancelar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .get(`${URL_ABONOS}Cancel/${idAbono}`, {
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then(() => {
            Swal.fire("Good job!", "Enviado con exito", "success");
            cargarAbonos();
          })
          .catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response?.data?.message || error.response?.data?.error || 'Ocurrió un error inesperado'}`,
            });
            console.log(error);
          });
      }
    });
  }

  // Función para validar un abono
  async function validarAbono(abonoId, validado) {
    if (validado === "Si") {
      try {
        // 1. Obtener datos del abono
        const abono = comments.find(a => a._id === abonoId);
        if (!abono) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "No se encontró el abono seleccionado"
          });
          return;
        }

        // 2. Si el abono no tiene pedido asociado, validar normalmente
        if (!abono.idNota || abono.idNota === "Sin nota") {
          await validarAbonoNormal(abonoId, validado);
          return;
        }

        // 3. Obtener datos del pedido para verificar saldo
        const pedidoResponse = await axios.get(`${URL_PEDIDOS}/${abono.idNota}`, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        });

        const pedido = pedidoResponse.data;
        const saldoPedido = pedido.saldo || 0;

        // 4. Verificar si importe > saldo del pedido (asegurar comparación numérica)
        const importeNumerico = parseFloat(abono.importe) || 0;
        const saldoNumerico = parseFloat(saldoPedido) || 0;

        if (importeNumerico > saldoNumerico) {
          const excedente = importeNumerico - saldoNumerico;
          
          // 5. Mostrar confirmación
          const resultado = await Swal.fire({
            title: "Abono mayor al saldo",
            html: `El abono de <strong>$${importeNumerico.toFixed(2)}</strong> excede el saldo de <strong>$${saldoNumerico.toFixed(2)}</strong><br>
                   Diferencia: <strong>$${excedente.toFixed(2)}</strong><br><br>
                   ¿Desea convertir los <strong>$${excedente.toFixed(2)}</strong> en un anticipo para el cliente?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, crear anticipo",
            cancelButtonText: "Cancelar validación",
            confirmButtonColor: "#28a745",
            cancelButtonColor: "#dc3545"
          });
          
          if (resultado.isConfirmed) {
            try {
              // 6. Actualizar abono al saldo exacto
              await axios.patch(
                `${URL_ABONOS}EditarAbono/${abonoId}`,
                { importe: saldoNumerico },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              // 7. Crear anticipo por diferencia usando el nuevo endpoint
              const anticipoData = {
                fecha: moment().format("YYYY-MM-DD"),
                importe: excedente,
                clientes: abono.idClientes,
                formaPago: abono.formaPago || "Transferencia",
                saldo: excedente,
                utilizado: 0
              };

              // Agregar banco del abono
              if (abono.idBancos) {
                anticipoData.bancos = abono.idBancos;
              } else {
                // Fallback al primer banco disponible
                if (bancos && bancos.length > 0) {
                  anticipoData.bancos = bancos[0]._id;
                } else {
                  throw new Error("Se requiere un banco para crear el anticipo");
                }
              }

              await axios.post(`${URL_ANTICIPOS}/fromAbono`, anticipoData, {
                headers: {
                  Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  "Content-Type": "application/json",
                },
              });

              // 8. Validar el abono ajustado
              await axios.patch(
                `${URL_ABONOS}Validate/${abonoId}`,
                { validado: "Si" },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                    "Content-Type": "application/json",
                  },
                }
              );

              // Actualizar la lista de abonos localmente
              setComments((prev) =>
                prev.map((a) =>
                  a._id === abonoId
                    ? { ...a, validado: "Si", importe: saldoNumerico }
                    : a
                )
              );

              // Log de la acción
              await axios.post(
                URL_LOGS,
                {
                  tipo: "Validar Abono con Anticipo",
                  detalle: `Abono ${abonoId} validado por $${saldoNumerico.toFixed(2)} y anticipo creado por $${excedente.toFixed(2)}`,
                  user: user.id,
                },
                {
                  headers: {
                    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                  },
                }
              );

              Swal.fire({
                icon: "success",
                title: "¡Operación completada!",
                html: `<strong>Abono validado:</strong> $${saldoNumerico.toFixed(2)}<br>
                       <strong>Anticipo creado:</strong> $${excedente.toFixed(2)}`,
                timer: 3000,
                showConfirmButton: true,
              });
              // Sin reload: el estado local ya se actualizó arriba (validado + importe).
            } catch (error) {
              console.error("Error en operación compleja:", error);
              Swal.fire({
                icon: "error",
                title: "Error",
                text: "Error al procesar la operación",
                footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
              });
            }
          }
          // Si cancela, no hacer nada
          return;
        }

        // Validación normal cuando importe <= saldo
        await validarAbonoNormal(abonoId, validado);

      } catch (error) {
        console.error("Error al obtener datos del pedido:", error);
        // Si hay error obteniendo el pedido, validar normalmente
        await validarAbonoNormal(abonoId, validado);
      }
    } else {
      // Invalidar abono (lógica original)
      await validarAbonoNormal(abonoId, validado);
    }
  }

  // Función auxiliar para validación normal
  async function validarAbonoNormal(abonoId, validado) {
    try {
      await axios.patch(
        `${URL_ABONOS}Validate/${abonoId}`,
        { validado: validado },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Actualizar la lista de abonos
      setComments((prev) =>
        prev.map((abono) =>
          abono._id === abonoId ? { ...abono, validado: validado } : abono
        )
      );

      Swal.fire({
        icon: "success",
        title: "¡Éxito!",
        text: `Abono ${
          validado === "Si" ? "validado" : "invalidado"
        } correctamente`,
        timer: 1000,
        showConfirmButton: false,
      });
      // Sin reload: el estado local ya se actualizó arriba con setComments.
    } catch (error) {
      console.error("Error al validar abono:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al validar el abono",
        footer: `${error.response?.data?.message || error.response?.data?.error || error.message}`,
      });
    }
  }

  return (
    <>
      <Header />
      <br />
      <br />
      {user.abonos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              {/* {user.abonosCreate ? (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  href="/AbonosCreate"
                >
                  Nuevo Abono
                </Button>
              ) : (
                <Button
                  size="sm"
                  type="submit"
                  className="btn btn-success"
                  disabled
                >
                  Nuevo Abono
                </Button>
              )} */}
              <Button
                size="sm"
                href="/MenuAdmin"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i className="far fa-file-pdf"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i className="fas fa-at"></i>
                </Button>
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado Abonos</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Reporte de Abonos</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tr>
              <td></td>
              <td></td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedCliente}
                  onChange={(e) => {
                    setSelectedCliente(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {clientes
                    .sort((a, b) =>
                      a.nombre_comercial > b.nombre_comercial ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre_comercial}</option>
                      );
                    })}
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  bsSize="sm"
                  type="select"
                  value={selectedVendedor}
                  onChange={(e) => {
                    setSelectedVendedor(e.target.value);
                    setCurrentPage(1);
                  }}
                >
                  <option value="">Selecciona</option>
                  {colaboradores
                    .sort((a, b) =>
                      a.nombre > b.nombre ? 1 : -1
                    )
                    .map((a) => {
                      return (
                        <option value={a._id}>{a.nombre}{a.apellido}</option>
                      );
                    })}
                </Input></td>

              {/* <td style={{ paddingTop: "0px" }}>
              <Input
                      type="select"
                      bsSize="sm"
                      value={selectedBanco}
                      onChange={(e) => {
                        setSelectedBanco(e.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {bancos
                        .sort((a, b) => (a.banco > b.banco ? 1 : -1))
                        .map((a) => {
                          return (
                            <option value={a._id}>
                              {a.banco} {a.cuenta}
                            </option>
                          );
                        })}
                    </Input>
              </td> */}
              <td style={{ paddingTop: "0px" }}>
                <Input
                  type="select"
                  bsSize="sm"
                  value={formaPago}
                  onChange={(e) => {
                    setFormaPago(e.target.value);
                  }}
                >
                  <option value="">Selecciona</option>
                  <option value="Efectivo">Efectivo</option>
                  <option value="Transfer">Transfer</option>
                  <option value="TDC">TDC</option>
                </Input>
              </td>
              <td style={{ paddingTop: "0px" }}>
                <Input
                  type="select"
                  bsSize="sm"
                  value={selectedConcepto}
                  onChange={(e) => {
                    setSelectedConcepto(e.target.value);
                  }}
                >
                  <option value="">Selecciona </option>
                  <option value="Abono">Abono</option>
                  <option value="Bonificacion">Bonificacion</option>
                  <option value="Devolucion">Devolucion</option>
                </Input>
              </td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
            <tbody>
              {commentsData.map((a) => {
                if (a.is_active == "No") {
                  return (
                    <tr className="row-cancelled">
                      <td>{a.numero}</td>
                      <td style={{ minWidth: 100 }}>{fmtFecha(a.fecha)}</td>
                      <td>{a.clientes}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.formaPago}</td>
                      <td>{a.concepto}</td>
                      <td>{a.observaciones}</td>
                      <td>{a.bancos}</td>

                      <td>
                        {new Intl.NumberFormat("en-US", {
                          style: "currency",
                          currency: "USD",
                          maximumFractionDigits: 2,
                        }).format(a.importe)}
                      </td>
                      <td>
                        <span
                          className={`badge ${
                            a.validado === "Si"
                              ? "badge-success"
                              : "badge-warning"
                          }`}
                        >
                          {a.validado == "Si" ? "Validado" : "No Validado"}
                        </span>
                      </td>
                      <td style={{ minWidth: 120 }}>CANCELADO</td>
                    </tr>
                  );
                } else {
                  if (a.editado == "Si") {
                    return (
                      <tr style={{ backgroundColor: "orange" }}>
                        <td>{a.numero}</td>
                        <td style={{ minWidth: 100 }}>{fmtFecha(a.fecha)}</td>
                        <td>{a.clientes}</td>
                        <td>{a.vendedor}</td> 
                        <td>{a.formaPago}</td>
                        <td>{a.concepto}</td>
                        <td>{a.observaciones}</td>
                        <td>{a.bancos}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.importe)}
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              a.validado === "Si"
                                ? "badge-success"
                                : "badge-warning"
                            }`}
                          >
                            {a.validado == "Si" ? "Validado" : "No Validado"}
                          </span>
                        </td>
                        <td style={{ minWidth: 120 }}>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.clientes,
                                a.importe,
                                a.nota,
                                a.formaPago,
                                a.observaciones,
                                a.numero
                              )
                            }
                          >
                            <i className="far fa-file-pdf"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) =>
                              EditAbono(
                                a._id,
                                a.numero,
                                a.fecha,
                                a.idClientes,
                                a.importe,
                                a.observaciones,
                                a.formaPago,
                                a.clientes,
                                a.idNota
                              )
                            }
                          >
                            <i className="far fa-edit"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) => cancelarAbono(a._id)}
                          >
                            <i className="fas fa-ban"></i>
                          </Button>
                          {user.abonosValidar ? (
                            <div>
                              {a.validado === "Si" ? (
                                <Button
                                  size="sm"
                                  color="warning"
                                  onClick={() => validarAbono(a._id, "No")}
                                  title="Invalidar"
                                >
                                  <i className="fas fa-times"></i>
                                </Button>
                              ) : (
                                <Button
                                  size="sm"
                                  color="success"
                                  onClick={() => validarAbono(a._id, "Si")}
                                  title="Validar"
                                >
                                  <i className="fas fa-check"></i>
                                </Button>
                              )}
                            </div>
                          ) : null}
                        </td>
                      </tr>
                    );
                  } else {
                    return (
                      <tr>
                        <td>{a.numero}</td>
                        <td style={{ minWidth: 100 }}>{fmtFecha(a.fecha)}</td>
                        <td>{a.clientes}</td>
                        <td>{a.vendedor}</td>
                        <td>{a.formaPago}</td>
                        <td>{a.concepto}</td>
                        <td>{a.observaciones}</td>
                        <td>{a.bancos}</td>
                        <td>
                          {new Intl.NumberFormat("en-US", {
                            style: "currency",
                            currency: "USD",
                            maximumFractionDigits: 2,
                          }).format(a.importe)}
                        </td>
                        <td>
                          <span
                            className={`badge ${
                              a.validado === "Si"
                                ? "badge-success"
                                : "badge-warning"
                            }`}
                          >
                            {a.validado == "Si" ? "Validado" : "No Validado"}
                          </span>
                        </td>
                        <td style={{ minWidth: 120 }}>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) =>
                              PDFOC(
                                a.fecha,
                                a.clientes,
                                a.importe,
                                a.nota,
                                a.formaPago,
                                a.observaciones,
                                a.numero
                              )
                            }
                          >
                            <i className="far fa-file-pdf"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="info"
                            onClick={(e) =>
                              EditAbono(
                                a._id,
                                a.numero,
                                a.fecha,
                                a.idClientes,
                                a.importe,
                                a.observaciones,
                                a.formaPago,
                                a.clientes,
                                a.idNota
                              )
                            }
                          >
                            <i className="far fa-edit"></i>
                          </Button>
                          <Button
                            size="sm"
                            className="btn"
                            color="danger"
                            onClick={(e) => cancelarAbono(a._id)}
                          >
                            <i className="fas fa-ban"></i>
                          </Button>
                          {user.abonosValidar ? (
                            <div>
                              {a.validado === "Si" ? (
                                <Button
                                  size="sm"
                                  color="warning"
                                  onClick={() => validarAbono(a._id, "No")}
                                  title="Invalidar"
                                >
                                  <i className="fas fa-times"></i>
                                </Button>
                              ) : (
                                <Button
                                  size="sm"
                                  color="success"
                                  onClick={() => validarAbono(a._id, "Si")}
                                  title="Validar"
                                >
                                  <i className="fas fa-check"></i>
                                </Button>
                              )}
                            </div>
                          ) : null}
                        </td>
                      </tr>
                    );
                  }
                }
              })}
              <tr>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td></td>
                <td className="negrita" align="center">
                  TOTAL GENERAL
                </td>
                <td className="negrita">
                  {new Intl.NumberFormat("en-US", {
                    style: "currency",
                    currency: "USD",
                    maximumFractionDigits: 2,
                  }).format(totalTotalTabla)}
                </td>
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />
      <Modal size="sm" isOpen={modalEdit} toggle={toggleEdit}>
        <ModalHeader toggle={toggleEdit}>
          <h4>
            Editar Abono {numeroEdit} {clienteEdit}
          </h4>
        </ModalHeader>
        <ModalBody>
          <Form onSubmit={EditAbonoSave}>
            <Row>
              <Col md={6}>
                <Label>Fecha</Label>
                <Input
                  type="date"
                  value={fechaEdit}
                  required
                  onChange={(e) => {
                    setFechaEdit(e.target.value);
                  }}
                />
              </Col>
              <Col md={6}>
                <Label>Importe</Label>
                <Input
                  className="col-sm-12"
                  type="number"
                  placeholder="Importe"
                  value={importeEdit}
                  required
                  onChange={(e) => {
                    setImporteEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col md={12}>
                <Label>Observaciones</Label>
                <Input
                  className="col-sm-12"
                  type="text"
                  placeholder="Observaciones"
                  value={observacionesEdit}
                  required
                  onChange={(e) => {
                    setObservacionesEdit(e.target.value);
                  }}
                />
              </Col>
            </Row>

            <br />
            <Row>
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            </Row>
          </Form>
        </ModalBody>
      </Modal>

      {loader}
    </>
  );
}

export default ListadoAbonos;
